<template>
  <transition name="fade">
    <div id="show-jobs">
      <h2>{{ msg }}</h2>
      <div id="search">
        <input type="text" v-model="search" placeholder="Search Jobs">
        <button class="floating-btn" v-if="search" @click="search = ''">Clear</button>
      </div>
      <section id="jobs-panel">
        <div :class="{toggled: isToggled}" class="paper" v-if="isToggled">
          <button @click="close_user_data">×</button>
          <h3>{{ user.title }}</h3>
          <h3>{{ user.username }}</h3>
          <p>{{ user.program }}</p>
          <p v-if="user.email">{{ user.email }}</p>
          <h4>Input</h4>
          <p class="input">{{ user.input }}</p>
          <h4>Output</h4>
          <p v-if="user.outFile">
            <template v-for="file in user.fileURLs">
              <a :href="file" download :key="file">Download File</a>
              <br :key="file">
            </template>
          </p>
          <pre class="stdout">{{ user.output }}</pre>
          <p class="time">{{ user.timestamp | date('%D %T') }}</p>
          <a href="https://biomall.cs.uno.edu/software">Download local copy of the software.</a>
        </div>
        <paginate name="filtered-jobs" :list="filteredJobs" :per="jobsPerPage">
          <article
            :key="job.timestamp"
            :class="{ wait: !job.done}"
            class="paper"
            @click="get_user(job)"
            tabindex="0"
            v-for="job in paginated('filtered-jobs')"
          >
            <h3>{{ job.title | truncate(18,'...')}}</h3>
            <h4>{{ job.username }}</h4>
            <p>{{ job.program }}</p>
            <form @submit.prevent="get_private_user(job)" class="private" v-if="job.private">
              <input
                :class="{invalid: job.invalidPass}"
                v-model="job.passkey"
                placeholder="passkey"
                type="text"
              >
              <button class="floating-btn" v-if="job.passkey">View</button>
            </form>
            <p class="time">{{ job.timestamp | date('%D %T') }}</p>
          </article>
        </paginate>
        <paginate-links for="filtered-jobs" :limit="5"></paginate-links>
	<p class="center">Can't find your job?</p>
	<p>We automatically delete jobs older than six months to keep our database size managable. Please feel free to send a new job instead.</p>
      </section>
    </div>
  </transition>
</template>
<script>
import axios from "axios";
export default {
  name: "showJobs",
  data() {
    return {
      msg: "Job Queue",
      jobsPerPage: 15,
      paginate: ['filtered-jobs'],
      jobs: [],
      search: "",
      isToggled: false,
      user: {}
    };
  },
  methods: {
    getJobs() {
      axios.get(process.env.VUE_APP_API_HOST+'/api/users')
        .then(res => (this.jobs = res.data))
        .catch(err => console.log(err));
    },
    close_user_data() {
      this.isToggled = false;
    },
    get_user_data(job) {
      axios.post(process.env.VUE_APP_API_HOST +'/api/users/' + job.id, job)
        .then(res => {
          this.user = res.data;
          this.isToggled = true;
          window.scrollTo(0, 0);
        })
        .catch(err => {
          console.log(err);
          job.invalidPass = true;
        });
    },
    get_private_user(job) {
      if (job.passkey != "") this.get_user_data(job);
    },
    get_user(job) {
      if (!job.private) this.get_user_data(job);
    }
  },
  mounted() {
    this.getJobs();
  },
  computed: {
    filteredJobs() {
      let filtered = this.jobs.filter(job => {
        let matched = job.title.toLowerCase().match(this.search.toLowerCase()) || job.program.toLowerCase().match(this.search.toLowerCase());
        if(job.username != null)
          return job.username.toLowerCase().match(this.search.toLowerCase()) || matched;
        else
          return matched;
      });
      filtered.sort((a, b) => {
        return a.timestamp < b.timestamp;
      });
      return filtered;
    }
  }
};
</script>
<style scoped>
#search {
  box-sizing: border-box;
  width: 70%;
  margin-left: 15%;
  text-align: center;
  margin-bottom: var(--gap-huge);
  position: relative;
}
#search input {
  width: 100%;
  box-sizing: border-box;
}
#jobs-panel ul {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: var(--gap-huge);
}
#jobs-panel .paginate-links {
  display: flex;
}
#jobs-panel .paper:focus,
#jobs-panel .paper:hover {
  outline: none;
  cursor: pointer;
  box-shadow: 5px 5px 0 var(--shadow);
}
#jobs-panel .paper.toggled:hover {
  cursor: default;
}
#jobs-panel .wait {
  opacity: 0.5;
}
#jobs-panel .time {
  font-size: 0.8em;
}
#jobs-panel .stdout {
  background: var(--shadow-dark);
  box-shadow: inset 5px 5px 0 var(--shadow);
  color: white;
  padding: var(--gap);
  max-height: 15em;
  overflow-y: auto;
}
#jobs-panel p.input {
  max-height: 15em;
  overflow-y: auto;
}
.paper.toggled {
  grid-column: 1 / 4;
  margin: 50px;
  box-sizing: border-box;
  max-width: calc(100% - 100px);
  box-shadow: 5px 5px var(--shadow);
}
.paper.toggled p {
  word-wrap: break-word;
}
.paper pre {
  white-space: pre-line;
}
.paper .private {
  position: relative;
}
.paper .private input {
  display: block;
  box-sizing: border-box;
  width: 100%;
}
ul {
  padding: 0;
  margin: 0;
}
.paginate-links {
  margin: var(--gap-huge) 0;
}
</style>
